.sw-usecase-detail .ins-post-deck { max-width: 65ch; }
.sw-usecase-byline { display: flex; flex-wrap: wrap; gap: 0.5rem 1.5rem; margin: 1.5rem 0; color: var(--brand-soft-white); font-size: 0.875rem; }
.sw-usecase-byline a { color: inherit; text-decoration: underline; text-underline-offset: 0.2em; }
.sw-usecase-prose { color: var(--text-primary); font-size: 1rem; line-height: 1.75; }
.sw-usecase-prose section { scroll-margin-top: 7rem; }
.sw-usecase-prose section + section { margin-top: 3rem; }
.sw-usecase-prose h2 { margin: 0 0 1rem; font-size: clamp(1.4rem, 2.2vw, 2rem); line-height: 1.25; color: var(--text-primary); text-wrap: balance; }
.sw-usecase-prose h3 { margin: 1.75rem 0 0.75rem; font-size: 1.15rem; line-height: 1.4; color: var(--text-primary); }
.sw-usecase-prose p { margin: 0 0 1rem; }
.sw-usecase-prose ul, .sw-usecase-prose ol { padding-inline-start: 1.5rem; }
.sw-usecase-prose li + li { margin-top: 0.75rem; }
.sw-usecase-table { width: 100%; }
.sw-usecase-table table { width: 100%; border-collapse: collapse; table-layout: fixed; }
.sw-usecase-table th, .sw-usecase-table td { padding: 1rem; text-align: start; vertical-align: top; overflow-wrap: anywhere; border-bottom: 1px solid var(--border-default); }
.sw-usecase-table th { color: var(--text-primary); background: var(--bg-sunken); }
.sw-usecase-outline { display: grid; gap: 1rem; position: sticky; top: 7rem; }
.sw-usecase-outline a { color: var(--text-primary); text-underline-offset: 0.2em; }
.sw-usecase-detail a:focus-visible { outline: 2px solid var(--accent-blue); outline-offset: 4px; }
.sw-usecase-detail .sw-btn { white-space: normal; text-align: center; }
@media (max-width: 760px) {
  .sw-usecase-detail .ins-post-title { font-size: clamp(2rem, 8vw, 3rem); }
  .sw-usecase-detail .ins-post-body { grid-template-columns: minmax(0, 1fr); }
  .sw-usecase-table th, .sw-usecase-table td { padding: 0.75rem 0.5rem; font-size: 0.9375rem; }
  .sw-usecase-detail .sw-cta-actions { display: grid; grid-template-columns: minmax(0, 1fr); }
}

